import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var leaveStatusListRes;
export const leaveStatusListTodo = createAsyncThunk('leaveStatusList', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'hr/leave_status',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token,
                "ibusiness_area_id": user_id.ibusiness_area_id,
                "vfin_year_name": data.year,
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return leaveStatusListRes = res.data
    } catch (error) {
        return leaveStatusListRes = error.response.data
    }
})


const leaveStatusListSlice = createSlice({
    name: 'leaveStatusList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(leaveStatusListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('leaveStatusList', state.data)
            }
        });
        builder.addCase(leaveStatusListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default leaveStatusListSlice.reducer; 